(function() {
    const $imageMaps = document.querySelectorAll('.image-mapper')
    $imageMaps.forEach(async ($im) => {
        const {ImageMapper} = await import(/* webpackChunkName: "imageMapper" */'./ImageMapper')
        new ImageMapper($im)
    })
})()